<template>
    <div class="report">
        <div class="open-wrapper pointer" @click="openModal">
            <slot>
                <a href="javascript://void(0)">Open</a>
            </slot>
        </div>

        <modal :name=modalId
               :adaptive="true"
               :scrollable="true"
               height="auto">
            <div class="dashboard-block" :class="{loading: loading}">
                <header>
                    <h4 v-if="report.created_at" class="display-block">
                        {{report.displayName}}

                        <span v-if="report.archivedLabel"
                              v-html="report.archivedLabel"></span>
                    </h4>
                    <h4 v-else class="display-block">
                        Create Report
                    </h4>

                    <h5 v-if="report.created_at">
                        Report
                    </h5>

                    <a href="javascript://void(0)" class="back" @click="closeModal">Close</a>
                </header>

                <div class="row" v-if="report.created_at">
                    <div class="col-xs-6" v-if="report.nextSendAt">
                        <dl>
                            <dt>Next Send Date</dt>
                            <dd>{{report.nextSendAt.local().format('MMM Do, YYYY')}}</dd>
                        </dl>
                    </div>
                </div>

                <tabs>
                    <tab :title="report.created_at ? 'Edit' : 'Create Report'">
                        <fieldset>
                            <legend>Report</legend>

                            <form @submit.prevent="saveReport" accept-charset="UTF-8"
                                  data-vv-scope="report" novalidate="novalidate">

                                <div class="form-group has-feedback"
                                     v-if="isScheduled"
                                     :class="{'has-error': errors.has('report.Report[scheduleType]')}">
                                    <div class="btn-group btn-group-justified" role="group">
                                        <div class="btn-group" role="group">
                                            <button type="button"
                                                    :class="{ active: isMonthly }"
                                                    class="btn btn-sm btn-info"
                                                    @click="scheduleType = SCHEDULE_TYPE_MONTHLY">
                                                Monthly
                                            </button>
                                        </div>

                                        <div class="btn-group" role="group">
                                            <button type="button"
                                                    :class="{ active: isWeekly }"
                                                    class="btn btn-sm btn-primary"
                                                    @click="scheduleType = SCHEDULE_TYPE_WEEKLY">
                                                Weekly
                                            </button>
                                        </div>

                                        <div class="btn-group" role="group">
                                            <button type="button"
                                                    :class="{ active: isSingle }"
                                                    class="btn btn-sm btn-primary"
                                                    @click="scheduleType = SCHEDULE_TYPE_DATE">
                                                Date
                                            </button>
                                        </div>
                                    </div>

                                    <span v-show="errors.has('report.Report[scheduleType]')" class="help-block">
                                        {{ errors.first('report.Report[scheduleType]') }}
                                    </span>
                                </div>

                                <div class="form-group has-feedback"
                                     :class="{'has-error': errors.has('report.Report[name]')}">
                                    <label for="report-name">Name</label>

                                    <select id="report-name"
                                            v-validate="'required'"
                                            v-model="report.name"
                                            name="Report[name]"
                                            class="form-control"
                                            aria-required="true">
                                        <option v-for="( reportDetails, key ) in filteredReportNames" :value="key" :key="key">
                                            {{reportDetails.title}}
                                        </option>
                                    </select>

                                    <span v-show="errors.has('report.Report[name]')" class="help-block">
                                        {{ errors.first('report.Report[name]') }}
                                    </span>
                                </div>

                                <div class="form-group has-feedback"
                                     v-if="!userId"
                                     :class="{'has-error': errors.has('report.Report[user_id]')}">
                                    <label for="report-user-id">User</label>

                                    <select id="report-user-id"
                                            v-validate="'required'"
                                            v-model="report.user_id"
                                            name="Report[user_id]"
                                            class="form-control"
                                            aria-required="true">
                                        <option v-for="user in users" :value="user.id" :key="user.id">
                                            {{user.first_name}} {{user.last_name}} ({{user.email}})
                                        </option>
                                    </select>

                                    <span v-show="errors.has('report.Report[user_id]')" class="help-block">
                                        {{ errors.first('report.Report[user_id]') }}
                                    </span>
                                </div>

                                <div class="row">
                                    <div class="col-sm-6 form-group has-feedback"
                                         v-if="isMonthly && isScheduled"
                                         :class="{'has-error': errors.has('report.Report[date]')}">
                                        <label for="report-date">Day of Month</label>

                                        <input id="report-date"
                                               v-validate="'required|min_value:1|max_value:31'"
                                               v-model="report.date"
                                               name="Report[date]"
                                               type="number"
                                               class="form-control"
                                               aria-required="true">

                                        <span v-show="errors.has('report.Report[date]')" class="help-block">
                                            {{ errors.first('report.Report[date]') }}
                                        </span>
                                    </div>

                                    <div class="col-sm-6 form-group has-feedback"
                                         v-if="isWeekly && isScheduled"
                                         :class="{'has-error': errors.has('report.Report[day]')}">
                                        <label for="report-day">Day of Week</label>

                                        <select id="report-day"
                                                v-validate="'required'"
                                                v-model="report.day"
                                                name="Report[day]"
                                                class="form-control"
                                                aria-required="true">
                                            <option v-for="( label, value ) in daysOfWeek" :value="value"
                                                    :key="value">
                                                {{label}}
                                            </option>
                                        </select>

                                        <span v-show="errors.has('report.Report[day]')" class="help-block">
                                            {{ errors.first('report.Report[day]') }}
                                        </span>
                                    </div>

                                    <div class="col-sm-6 form-group has-feedback"
                                         v-if="isSingle && isScheduled"
                                         :class="{'has-error': errors.has('report.Report[schedule_at]')}">
                                        <label for="report-schedule-at">Send Report On</label>

                                        <input id="report-schedule-at"
                                                v-validate="'required'"
                                                v-model="report.schedule_at"
                                                name="Report[schedule_at]"
                                                class="form-control"
                                                aria-required="true"
                                                type="date">

                                        <span v-show="errors.has('report.Report[schedule_at]')" class="help-block">
                                            {{ errors.first('report.Report[schedule_at]') }}
                                        </span>
                                    </div>
                                </div>

                                <hr>

                                <div class="row">
                                    <div class="col-xs-6">
                                        <button type="button" class="btn btn-sm btn-warning"
                                                @click="deleteReport"
                                                v-if="report.created_at && report.deleted_at === null"
                                                :disabled="loading">
                                            <i class="fa fa-trash" aria-hidden="true"></i>
                                        </button>

                                        <button type="button" class="btn btn-sm btn-warning"
                                                @click="restoreReport"
                                                v-if="report.created_at && report.deleted_at !== null"
                                                :disabled="loading">
                                            <i class="fa fa-refresh" aria-hidden="true"></i>
                                        </button>
                                    </div>

                                    <div class="col-xs-6 form-group pull-right">
                                        <button type="submit" class="btn btn-success btn-block" :disabled="loading">
                                            Save
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </fieldset>
                    </tab>

                    <tab title="Email Notifications" v-if="report.created_at">
                        <fieldset>
                            <legend>Email Notifications</legend>

                            <ul class="list-group no-margin" v-if="report.emailNotifications">
                                <li class="list-group-item"
                                    v-if="report.emailNotifications && report.emailNotifications.length === 0">
                                    No Emails Sent
                                </li>

                                <li class="list-group-item link"
                                    :class="{
                                            'active list-group-item-success': !emailNotification.sent_at && emailNotification.id === listEmailNotification.id
                                        }"
                                    v-bind:key="listEmailNotification.id"
                                    v-for="listEmailNotification in report.emailNotifications"
                                    @click="emailNotification = listEmailNotification">

                                    <h5 class="margin-sm-bottom">
                                        {{listEmailNotification.subject}}
                                    </h5>

                                    <h6 class="margin-sm-bottom">
                                        <a :href="'mailto:' + listEmailNotification.to">{{listEmailNotification.to}}</a>
                                    </h6>

                                    <div class="row">
                                        <div class="col-sm-7">
                                            <span class="label label-success"
                                                  v-if="listEmailNotification.sent_at !== null">
                                                Sent at {{listEmailNotification.sent_at}}
                                            </span>
                                            <span class="label label-warning" v-else>
                                                Pending Send
                                            </span>
                                        </div>
                                        <div class="col-sm-5 align-sm-right"
                                             v-if="!emailNotification.sent_at && listEmailNotification.id === emailNotification.id">
                                            <button class="btn btn-sm btn-warning" type="button"
                                                    @click="deleteEmailNotification(emailNotification)">
                                                <i class="fa fa-trash" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </fieldset>
                    </tab>
                </tabs>
            </div>
        </modal>
    </div>
</template>

<script>
    const { daysOfWeek } = require( '../constants.json' );
    const SCHEDULE_TYPE_MONTHLY = 0, SCHEDULE_TYPE_WEEKLY = 1, SCHEDULE_TYPE_DATE = 2;

    export default {
        props: {
            afterSave: {
                default(){
                    return function(){
                    };
                }
            },

            modalId: {
                default: Math.random().toString(),
                type: String
            },

            reportId: {
                type: String,
                default(){
                    return null;
                },
            },

            reportableId: {
                type: String,
                required: true
            },

            reportableType: {
                type: String,
                required: true,
                default: 'App\\Report'
            },

            reportNames: {
                type: Object,
                required: true,
            },

            userId: {
                type: String,
                default(){
                    return null;
                }
            }
        },

        created(){
            this.init();
        },

        data(){
            return {
                loading: true,

                project: {},

                emailNotification: {},

                reportable: {},

                report: {
                    date: 1,
                    day: null,
                    schedule_at: null,
                    name: null,
                    user_id: this.userId,
                },

                scheduleType: SCHEDULE_TYPE_MONTHLY,

                daysOfWeek,
                SCHEDULE_TYPE_MONTHLY,
                SCHEDULE_TYPE_WEEKLY,
                SCHEDULE_TYPE_DATE,
            };
        },

        computed: {
            daysOfMonth(){
                var result = [];

                for( let i = 1; i <= 31; i++ ){
                    result.push( i );
                }

                return result;
            },

            filteredReportNames(){
                var filteredReports = Object.assign({}, this.reportNames);
                if (this.scheduleType === SCHEDULE_TYPE_MONTHLY || this.scheduleType === SCHEDULE_TYPE_WEEKLY) {
                    Object.keys(filteredReports).forEach(key => {
                        if (!filteredReports[key].recurring) delete filteredReports[key];
                    })
                }
                else if (this.scheduleType === SCHEDULE_TYPE_DATE) {
                    Object.keys(filteredReports).forEach(key => {
                        if (!filteredReports[key].single) delete filteredReports[key];
                    })
                }

                return filteredReports;
            },

            isMonthly(){
                return this.scheduleType === SCHEDULE_TYPE_MONTHLY;
            },

            isWeekly(){
                return this.scheduleType === SCHEDULE_TYPE_WEEKLY;
            },

            isSingle(){
                return this.scheduleType === SCHEDULE_TYPE_DATE;
            },

            isScheduled(){
                if( this.report.name ){
                    return this.filteredReportNames[ this.report.name ].scheduled;
                }

                return true;
            },

            users(){
                if( this.project ){
                    return _.orderBy( this.project.managerUsers, [ 'fullName' ], [ 'asc' ] );
                }
            }
        },

        watch: {
            scheduleType(){
                if( this.isMonthly ){
                    this.report.day = null;
                    this.report.schedule_at = null;
                }
                else if( this.isWeekly ){
                    this.report.date = null;
                    this.report.schedule_at = null;
                }
                else if( this.isSingle ){
                    this.report.date = null;
                    this.report.day = null;
                }

                this.setFields();
            },

            "report.name"(){
                if( !this.isScheduled ){
                    this.report.day = null;
                    this.report.date = null;
                    this.report.schedule_at = null;
                }
            },

            reportId(){
                this.resetData();

                this.$nextTick( () => {
                    this.init();
                } );
            },
        },

        filters: {},

        methods: {
            setFields(){
                if( !this.report.created_at ){

                    if( this.users.length === 1 ){
                        this.report.user_id = _.head( this.users ).id;
                    }

                    this.report.name = _.head( _.keys( this.filteredReportNames ) );
                }
            },

            saveReport(){
                var url = '/api/reports';

                return this.$validator.validateAll( 'report' )
                    .then( ( valid ) => {
                        if( valid ){
                            var promise;

                            if( this.report.id ){
                                promise = axios.put( url + '/' + this.report.id, {
                                    Report: this.report
                                } );
                            }
                            else {
                                this.report.reportable_type = this.reportableType;
                                this.report.reportable_id = this.reportableId;

                                promise = axios.post( url, {
                                    Report: this.report
                                } );
                            }

                            return promise.then( ( result ) => {
                                if( !this.report.id ){
                                    this.report = result.data.Report;
                                }

                                return this.loadReport();
                            } )
                                .then( () => {
                                    this.afterSave();
                                    this.closeModal();

                                    this.$notify( {
                                        type: 'success',
                                        placement: 'top-left',
                                        title: 'Saved Report',
                                    } );
                                } )
                                .finally( () => {
                                    this.loading = false;
                                } )
                                .catch( ( err ) => {
                                    return this.$root.handleErrors( err, 'report' );
                                } );
                        }
                    } );
            },

            deleteReport(){
                this.loading = true;

                return axios.delete( '/api/reports/' + this.reportId )
                    .then( () => {
                        this.closeModal();
                        this.afterSave();

                        this.$notify( {
                            type: 'success',
                            placement: 'top-left',
                            title: 'Deleted Report',
                        } );
                    } )
                    .finally( () => {
                        this.loading = false;
                    } )
                    .catch( ( err ) => {
                        return this.$root.handleErrors( err, 'report' );
                    } );
            },

            restoreReport(){
                this.loading = true;

                return axios.put( '/api/reports/' + this.reportId + '/restore' )
                    .then( () => {
                        this.afterSave();

                        this.$notify( {
                            type: 'success',
                            placement: 'top-left',
                            title: 'Restored Report',
                        } );

                        return this.loadReport();
                    } )
                    .finally( () => {
                        this.loading = false;
                    } )
                    .catch( ( err ) => {
                        return this.$root.handleErrors( err, 'report' );
                    } );
            },

            loadProject(){
                var url = '/api/projects/' + this.reportableId + '?_load[]=managerUsers';

                return axios.get( url )
                    .then( ( response ) => {
                        this.$set( this, 'project', response.data.Project );
                    } );
            },

            loadReport(){
                var url = '/api/reports/' + this.report.id;

                return axios.get( url )
                    .then( ( response ) => {
                        var report = response.data.Report;

                        report.nextSendAt = report.nextSendAt ? moment.utc( report.nextSendAt ) : null;
                        if (report.date !== null) { this.scheduleType = SCHEDULE_TYPE_MONTHLY }
                        else if (report.day !== null) { this.scheduleType = SCHEDULE_TYPE_WEEKLY }
                        else if (report.schedule_at !== null) { this.scheduleType = SCHEDULE_TYPE_DATE }
                        report.schedule_at !== null ? report.schedule_at.slice(0, 10) : null;

                        this.$set( this, 'report', report );
                    } );
            },

            // Email Notification
            deleteEmailNotification( emailNotification ){
                return axios.delete( '/api/emailNotifications/' + emailNotification.id )
                    .then( () => {
                        this.afterSave();

                        this.$notify( {
                            type: 'success',
                            placement: 'top-left',
                            title: 'Archived Email Notification',
                        } );

                        return this.init();
                    } )
                    .finally( () => {
                        this.loading = false;
                    } )
                    .catch( ( err ) => {
                        this.$root.handleErrors( err, 'notifications' );
                    } );
            },

            init(){
                this.loading = true;

                var promises = [];

                if( this.reportableType === 'App\\Project' ){
                    promises.push( this.loadProject() );
                }

                if( this.reportId ){
                    this.report.id = this.reportId;

                    promises.push( this.loadReport() );
                }

                return Promise.all( promises )
                    .then( () => {
                        this.setFields();
                    } )
                    .finally( () => {
                        this.loading = false;
                    } )
                    .catch( this.$root.handleErrors );
            },

            resetData(){
                Object.assign( this.$data, this.$options.data() );
            },

            closeModal(){
                this.$modal.hide( this.modalId );
            },

            openModal(){
                this.$modal.show( this.modalId );
            }
        }
    }
</script>
